var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08338 0H12.3686C15.2608 0 17.6063 2.34543 17.6063 5.23767V11.5229C17.6063 14.4151 15.2608 16.7606 12.3686 16.7606H6.08338C3.19113 16.7606 0.845703 14.4151 0.845703 11.5229V5.23767C0.845703 2.34543 3.19113 0 6.08338 0ZM12.3686 15.1893C14.3903 15.1893 16.035 13.5446 16.035 11.5229V5.23767C16.035 3.21593 14.3903 1.5713 12.3686 1.5713H6.08338C4.06164 1.5713 2.41701 3.21593 2.41701 5.23767V11.5229C2.41701 13.5446 4.06164 15.1893 6.08338 15.1893H12.3686ZM5.03584 8.38028C5.03584 6.06627 6.91198 4.19014 9.22598 4.19014C11.54 4.19014 13.4161 6.06627 13.4161 8.38028C13.4161 10.6943 11.54 12.5704 9.22598 12.5704C6.91198 12.5704 5.03584 10.6943 5.03584 8.38028ZM6.60715 8.38028C6.60715 9.82378 7.78248 10.9991 9.22598 10.9991C10.6695 10.9991 11.8448 9.82378 11.8448 8.38028C11.8448 6.93573 10.6695 5.76144 9.22598 5.76144C7.78248 5.76144 6.60715 6.93573 6.60715 8.38028ZM14.2888 3.87588C14.2888 4.18424 14.0388 4.43422 13.7304 4.43422C13.4221 4.43422 13.1721 4.18424 13.1721 3.87588C13.1721 3.56752 13.4221 3.31755 13.7304 3.31755C14.0388 3.31755 14.2888 3.56752 14.2888 3.87588Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d57733a671dd82cb86803ecc3dfefa53.svg";
export { ForwardRef as ReactComponent };